import { useRouter } from 'next/dist/client/router';
import React, { useState, useEffect } from 'react';
import cookies from 'react-cookies';
import { useSelector } from 'react-redux';
import COOKIES from '../../config/cookies/cookies';
import { LINK_MY_VOUCHERS } from '../../config/links/links';
import {
  ACTIVATE_ACCOUNT,
  ACTIVATE_PASSWORD_BTN,
  ACTIVATE_PASSWORD_EXPRESS_CHECKOUT_TITLE,
  ACTIVATE_PASSWORD_PLACEHOLDER_PASSWORD,
  ACTIVATE_PASSWORD_PLACEHOLDER_PASSWORD_CONFIRM,
  ACTIVATE_PASSWORD_TITLE,
} from '../../config/text/text';
import { removeCookie } from '../../helpers/cookieSetter';
import { redirectToURL } from '../../helpers/url';
import {
  resetPasswordToken,
  showActivatePasswordModal,
} from '../../helpers/user';
import WowModal from '../WowModal';
import Tile from '../_generic/tile/Tile';
import TileBody from '../_generic/tile/TileBody';
import ActivateList from '../password/ActivateList';
import ResetPasswordForm from '../reset-password/ResetPasswordForm';

const PasswordActivateModal = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const userEmail = useSelector((state) => state.user.userprofile.email);
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const requestId = resetPasswordToken();

  const isExpressCheckout = cookies?.load(COOKIES.expressRegister) === 'true';
  const hasPassword = cookies?.load(COOKIES.hasPassword) === 'true';
  // destination after successful reset and login
  const redirect = () => {
    removeCookie(COOKIES.expressRegister);
    setShowModal(false);
    redirectToURL(LINK_MY_VOUCHERS, router);
  };

  useEffect(() => {
    let isMounted = true;
    async function checkShowModal() {
      if (isAuthenticated && userEmail) {
        const isShowModal = await showActivatePasswordModal(
          isAuthenticated,
          userEmail,
        );
        if (isMounted) setShowModal(isShowModal);
      }
    }
    if (isExpressCheckout && !hasPassword) {
      setShowModal(true);
    } else {
      checkShowModal();
    }

    return () => {
      isMounted = false;
    };
  }, [isAuthenticated, userEmail]);

  return (
    <>
      <WowModal
        ariaLabelledBy=""
        backdrop="static"
        centered
        extraClasses="pw-activate"
        keyboard={false}
        setShowModal={setShowModal}
        showCloseButton={false}
        showHeader={false}
        showModal={showModal}
        size="md"
      >
        <Tile
          title={
            isExpressCheckout
              ? ACTIVATE_PASSWORD_EXPRESS_CHECKOUT_TITLE
              : ACTIVATE_PASSWORD_TITLE
          }
        >
          <TileBody nopadding>
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <ActivateList isExpressCheckout={isExpressCheckout} />
                </div>
                <div className="col-md-6">
                  <ResetPasswordForm
                    buttonText={
                      isExpressCheckout
                        ? ACTIVATE_ACCOUNT
                        : ACTIVATE_PASSWORD_BTN
                    }
                    confirmPasswordPlaceholder={
                      ACTIVATE_PASSWORD_PLACEHOLDER_PASSWORD_CONFIRM
                    }
                    passwordPlaceholder={ACTIVATE_PASSWORD_PLACEHOLDER_PASSWORD}
                    redirect={redirect}
                    requestId={requestId}
                    showTile={false}
                  />
                </div>
              </div>
            </div>
          </TileBody>
        </Tile>
      </WowModal>
    </>
  );
};

export default PasswordActivateModal;
